export default {
  path: '/goods-order',
  meta: {
    title: '',
    keepAlive: true,
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/goods-order`),
}



// WEBPACK FOOTER //
// ./src/views/GoodsOrder/router.js